export const redirectCheck = (e): boolean =>
  !e.target.closest('.fa-copy') &&
  !e.target.closest('.download-labels') &&
  e?.target?.tagName !== 'path';
